export default "__VITE_ASSET__Ctwf_B7R__"